import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Snackbar from 'material-ui/Snackbar';

class StatusText extends Component {
   constructor(props) {
      super(props);

      this.state = {
         snackBarAutoHideDuration: 9000,
         snackBarIsOpen: false,
         snackBarMessage: ''
      };

      this.handleRequestClose = this.handleRequestClose.bind(this);
   }

   handleRequestClose(e) {
      this.setState({
         snackBarIsOpen: false,
         snackBarMessage: ''
      });
   };

   componentWillReceiveProps(nextProps){
      if (!!nextProps.dataStatusText && nextProps.dataStatusText !== this.props.dataStatusText ){
         this.setState({
            snackBarIsOpen: true,
            snackBarMessage: nextProps.dataStatusText
         });
      } else if (!!nextProps.authStatusText && nextProps.authStatusText !== this.props.authStatusText ){
         this.setState({
            snackBarIsOpen: true,
            snackBarMessage: nextProps.authStatusText
         });
      }
   }

   render() {
      const {snackBarAutoHideDuration, snackBarIsOpen, snackBarMessage} = this.state;
      return (
         <Snackbar
            className="info-snackbar"
            open={snackBarIsOpen}
            message={snackBarMessage}
            bodyStyle={{backgroundColor:'rgba(239, 0, 0, 0.70)', minWidth:400, maxWidth:800, textAlign:'center'}}
            autoHideDuration={snackBarAutoHideDuration}
            onRequestClose={this.handleRequestClose}
         />
      );
   }
}

StatusText.propTypes = {
   authStatusText: PropTypes.string,
   dataStatusText: PropTypes.string
}

const mapStateToProps = (state) => ({
   authStatusText: state.auth.statusText,
   dataStatusText: state.data.statusText
});

export default connect(mapStateToProps)(StatusText);



// WEBPACK FOOTER //
// ./src/components/StatusText.js